import { loadEnvConfig } from '_/env-config';

(async () => {
  // First load the env/config.json file so we know which environment we are in.
  await loadEnvConfig();

  // After loading the env/config.json boot the application.
  await import(/* webpackChunkName: "app-boot" */ '_/app/app-boot');
})();
